"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _context = _interopRequireDefault(require("../../utils/context"));
var _Columns = _interopRequireDefault(require("../components/Columns"));
var _DocumentRegistry = _interopRequireDefault(require("../components/DocumentRegistry"));
var _jsxRuntime = require("react/jsx-runtime");
const Frontend = (props, documentsRegister, contentElementsRegister) => {
  return (0, _jsxRuntime.jsx)(_context.default.Provider, {
    value: {
      document: {
        id: props.id,
        type: props.type,
        slug: props.slug,
        isRoot: props.slug === '/'
      },
      media: props.media,
      meta: props.meta,
      categories: props.categories,
      breadcrumbs: props.breadcrumbs,
      appearance: props.appearance,
      i18n: props.i18n,
      navigation: props.navigation,
      customProperties: props.customProperties,
      documentsRegister,
      contentElementsRegister,
      navigationFooter: props.navigationFooter
    },
    children: (0, _jsxRuntime.jsx)(_DocumentRegistry.default, {
      children: (0, _jsxRuntime.jsx)(_Columns.default, {
        content: props.content
      })
    })
  });
};
var _default = Frontend;
exports.default = _default;